import React, { useState, useEffect } from "react";
import "./TimerSection.css";
import { FaBus } from "react-icons/fa";
import Wingo_modal from "../../Common/Common_Component/Common_Modal/Wingo_modal/Wingo_modal";

function TimerSection() {
  const [modalShow, setModalShow] = useState(false);

  const [time, setTime] = useState(30); // 30 second timer

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        if (prev === 0) {
          return 30; // restart timer
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const minutes = String(Math.floor(time / 60)).padStart(2, "0");
  const seconds = String(time % 60).padStart(2, "0");

  const numSrc = [
    "/assets/images/bet_Select_section/coint_0.png",
    "/assets/images/bet_Select_section/coint_1.png",
    "/assets/images/bet_Select_section/coint_2.png",
    "/assets/images/bet_Select_section/coint_3.png",
  ];

  return (
    <>
      <section className="TimerSection">
        <div className="TimerSection_bg_holder">
          <div className="img_holder">
            <img
              className="bg_holder"
              src="/assets/images/bet_Select_section/timer_card/timer_card_bg.png"
              alt="bg"
            />
          </div>
        </div>

        <div className="timer_section">
          <div className="row me-0 ms-0">
            <div className="col-6">
              <div className="timer_left">
                <div className="game_info">
                  <div
                    className="icon_circle"
                    onClick={() => setModalShow(true)}
                  >
                    <FaBus className="bus_icon" />
                    How To Play
                  </div>

                  <div className="game_text">
                    <h4>Money King 30 Sec</h4>
                  </div>

                  <div className="number_grid">
                    {numSrc.map((src, index) => (
                      <div key={index} className="number_circle">
                        <img
                          src={src}
                          className="num_img"
                          alt={`number-${index}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6">
              <div className="timer_right">
                <p className="time_label">Time Remaining</p>

                <div className="timer_box">
                  <span className="digit digit_1">{minutes[0]}</span>
                  <span className="digit">{minutes[1]}</span>
                  <span className="colon">:</span>
                  <span className="digit">{seconds[0]}</span>
                  <span className="digit digit_2">{seconds[1]}</span>
                </div>

                <p className="timer_id">20260203100051129</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Wingo_modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default TimerSection;